export default __webpack_public_path__ + "static/media/global-setting.a53cf796.svg";